import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

function ModalForm({ isOpen, onClose, formTitle, fields, onSubmit, message }) {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        // Initialize form data
        const initialData = {};
        fields.forEach(field => {
            initialData[field.id] = field.value || '';
        });
        setFormData(initialData);
    }, [fields]);

    const handleChange = (e, fieldId) => {
        setFormData({
            ...formData,
            [fieldId]: e.target.value
        });
    };

    const handleSubmit = () => {
        onSubmit(formData);
    };

    const handleClear = () => {
        const clearedData = {};
        fields.forEach(field => {
            clearedData[field.id] = '';
        });
        setFormData(clearedData);
    };

    const handleCancel = () => {
        handleClear();
        onClose();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleCancel}
            className="relative max-w-md w-full mx-auto mt-20 bg-white rounded-2xl shadow-2xl p-8 outline-none"
            overlayClassName="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-start justify-center z-50 p-4"
        >
            <div>
                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-900 mb-6">{formTitle}</h2>

                {/* Error Message */}
                {message && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                        <p className="text-sm text-red-600 font-medium">{message}</p>
                    </div>
                )}

                {/* Form Fields */}
                <div className="space-y-4 mb-6">
                    {fields.map((field, index) => (
                        <div key={index}>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {field.label}
                            </label>
                            <input
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                value={formData[field.id] || ''}
                                onChange={(e) => handleChange(e, field.id)}
                                placeholder={field.placeholder}
                                type={field.inputType}
                                name={field.name}
                                id={field.id}
                                maxLength={field.maxlength}
                                autoComplete="off"
                                onKeyPress={handleKeyPress}
                            />
                        </div>
                    ))}
                </div>

                {/* Buttons */}
                <div className="flex gap-3">
                    <button
                        onClick={handleCancel}
                        className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleClear}
                        className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-colors"
                    >
                        Clear
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="flex-1 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors shadow-md hover:shadow-lg"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ModalForm;
